import { Card, Dropdown, FloatButton, Pagination, Tooltip } from "antd";
import React from "react";
import { DownOutlined, PlusOutlined, LeftOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { formateDate } from "src/components/helpers/formateDate";
import { getTransactions } from "src/store/Slices/ClientsSlice";
import { useState } from "react";
import EditTransactions from "../Modals/EditTransactions";
const MobileClientsTransactions = ({
  page,
  setPage,
  setPageSize,
  transactionsInfo,
  setTransactionsInfo,
  clientInfo,
  getClientTransactionsList,
  getClientTransactionsListLoading,
  setTab,
  mnemo,
}) => {
  const dispatch = useDispatch();

  // const [openDeliteAbonementModal, setOpenDeliteAbonementModal] = useState(false)
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);

  const items = [
    {
      key: "1",
      label: "Возврат",
      onClick: () => {
        setIsOpenEditModal(true);
      },
      disabled: !mnemo?.children
        ?.find((el) => el.name === "Таблица тренировок")
        ?.children.find((ele) => ele.mnemo === "updateBtn"),
    },
  ];

  return (
    <>
      <EditTransactions
        transactionsModal={isOpenEditModal}
        setTransactionsModal={setIsOpenEditModal}
        clientInfo={clientInfo}
        transactionsInfo={transactionsInfo}
        // payload={payload}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Pagination
          defaultCurrent={page}
          pageSize={20}
          showSizeChanger={false}
          current={page}
          onChange={(page, pageSize) => {
            dispatch(
              getTransactions({
                UserId: clientInfo.id,
                count: pageSize,
                offset: pageSize * (page - 1),
              })
            );
            setPage(page);
            setPageSize(pageSize);
          }}
          total={getClientTransactionsList?.data?.value?.totalCount}
          page={page}
        />
        {getClientTransactionsList?.data?.value?.rows.map((element) => {
          return (
            <Card
              loading={getClientTransactionsListLoading}
              title={`Транзакция №: ${element.id}`}
              extra={
                <Dropdown
                  menu={{
                    items,
                  }}
                >
                  <a
                    onClick={() => {
                      setTransactionsInfo({
                        ...element,
                      });
                    }}
                    className="text-primary text-decoration-none"
                  >
                    Действия <DownOutlined />
                  </a>
                </Dropdown>
              }
              style={{ width: 330, marginTop: 16 }}
              key={element.key}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <div>Id транзакции:</div>
                  <div>ID абонемента:</div>
                  <div>Дата тразакции:</div>
                  <div>Дата начала абонемента:</div>
                  <div>Дата конца абонемента:</div>
                  <div>Стоимость покупки:</div>
                </div>
                <div>
                  <div>{element?.id ? element?.id : "-"}</div>
                  <div>
                    {element?.abonementId ? (
                      <Tooltip title={element?.abonementId}>
                        {element?.abonementId}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.transactionDate ? (
                      <Tooltip title={element?.transactionDate}>
                        {formateDate(element?.transactionDate)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.startDate ? (
                      <Tooltip title={element?.startDate}>
                        {formateDate(element?.startDate)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.endDate ? (
                      <Tooltip title={element?.endDate}>
                        {formateDate(element?.endDate)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </div>
            </Card>
          );
        })}
        <FloatButton
          style={{ right: 24 }}
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setIsOpenAddEditModal({ open: true, flag: "add" });
          }}
        />
        <FloatButton
          style={{ left: 24 }}
          type="primary"
          icon={<LeftOutlined />}
          onClick={() => {
            setTab("Клиенты");
          }}
        />
      </div>
    </>
  );
};

export default MobileClientsTransactions;
